// extracted by mini-css-extract-plugin
module.exports = {"content":"SplashScreen_content__JOSei","carousel":"SplashScreen_carousel___RfnU"};